// extracted by mini-css-extract-plugin
export var card = "Card-module--card--YaLCA";
export var cardMain = "Card-module--cardMain--4-eVk";
export var dark = "Card-module--dark--FbFr-";
export var light = "Card-module--light--1lffn";
export var cardIcon = "Card-module--cardIcon--39PFA";
export var lightIcon = "Card-module--lightIcon--3miMx";
export var darkIcon = "Card-module--darkIcon--1TEFJ";
export var cardHeader = "Card-module--cardHeader--3rRHq";
export var cardTitle = "Card-module--cardTitle--3b10r";